export default __webpack_public_path__ + "static/media/linkedin.74799758.png";